import { applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import promise from "redux-promise-middleware";
// import { loadingBarMiddleware } from "react-redux-loading-bar";
import { composeWithDevTools } from "redux-devtools-extension";

import { getHistory } from "Router/getHistory";
import { APP_ENV } from "Config";

const history = getHistory();

const composeEnhancers = APP_ENV === "prod" ? compose : composeWithDevTools;

// PROD Middlewares
const prodMiddlewares = [
  routerMiddleware(history),
  thunk,
  promise()
  // loadingBarMiddleware()
];

// DEV Middlewares
const devMiddlewares = [...prodMiddlewares, createLogger()];

const middlewares = APP_ENV === "prod" ? prodMiddlewares : devMiddlewares;

export const createEnhancer = () => {
  return composeEnhancers(applyMiddleware(...middlewares));
};



// WEBPACK FOOTER //
// ./src/store/createEnhancer.js